// 主页 登录 注册 密码修改
export default {
    "高指-智能工厂管理系统": "TaskMan Smart Factory Management System",
    "账户登录": "Account Login",
    "手机号": "Phone",
    "密码": "Password",
    "忘记密码": "Forgot Password",
    "登 录": "Log In",
    "其他登录方式：": "Other Login:",
    "请用钉钉APP": "Please use the DingTalk APP",
    "扫码二维码安全登录": "Scan the QR code for secure login",
    "返回": "Back",
    "完善登录信息": "Please complete the information",
    "取 消": "Cancel",
    "确 定": "Confirm",
    "该项不能为空": "This field cannot be empty",
    "手机号输入格式有误": "Incorrect phone number format",
    "密码格式有误": "Incorrect password format",
    "绑定成功！": "Binding successful!",
    "登录成功！": "Login successful!",
    "请输入手机号": "Please enter your phone number",
    "请输入验证码": "Please enter the verification code",
    "请设置新密码": "Please set a new password",
    "请确认新密码": "Please confirm the new password",
    "确 认": "Confirm",
    "验证码格式有误": "Incorrect verification code format",
    "密码格式有误": "Incorrect password format",
    "获取验证码": "Get Verification Code",
    "请输入正确的手机号！": "Please enter the correct phone number!",
    "验证码已发送！": "The verification code has been sent!",
    "两次密码输入不一致！": "The two passwords entered do not match!",
    "修改密码成功！": "Password change successful!",
    "秒后重新获取": "Resend in xx seconds",
    "智能工厂": "Smart Factory",
    "XOS管理": "XOS Management",
    "APS先进排程": "APS",
    "主页": "Homepage",
    "个人中心": "User Center",
    "用户管理": "User Management",
    "高指-智能工厂管理系统": "TaskMan Smart Factory Management System",
    "帮助文档": "Guideline",
    "退出登录": "Log Out",
    "取消": "Log Out",
    'TaskMan 用户中心': 'TaskMan User Center',
    "用户管理编辑": "User Management and Editing"
}